import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  dialog: {
    zIndex: `1000 !important`,
  },
  appBar: {
    position: 'relative',
  },
  toolbar: {
    height: 70,
  },
  title: {
    margin: 0,
    padding: 0,
    lineHeight: 1.2,
    fontWeight: 'bold',
  },
  subTitle: {
    fontSize: 15,
  },
  status: {
    fontWeight: 'bold',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    display: 'flex',
  },
  statusIcon: {
    marginLeft: theme.spacing(2),
  },
  container: {
    position: 'relative',
    padding: theme.spacing(4),
    width: '80%',
    maxWidth: 800,
    margin: '0 auto',
  },
  barTitle: {
    flexDirection: 'column',
    flex: 1,
    marginLeft: theme.spacing(2),
    overflowX: 'auto',
    whiteSpace: 'nowrap',
  },

  buttonContainer: {},
  deleteButton: {
    backgroundColor: theme.colors.danger,
    color: theme.colors.white,
    marginLeft: theme.spacing(1),
  },

  formStyle: {
    alignItems: 'flex-start !important',
    position: 'relative',
    maxWidth: '1000px !important',
    overflow: 'visible !important',
    height: 'auto',
  },
  titleStyle: {
    fontSize: '18px !important',
    fontWeight: 'bold',
  },
  screenWidth: {
    width: '100%',
    '& .MuiInput-formControl.Mui-disabled, .MuiInputLabel-formControl': {
      color: theme.palette.text.primary,
    },
    '& .Mui-disabled.MuiInputBase-formControl .MuiSelect-icon': {
      display: 'none',
    },
    '& .Mui-disabled.MuiInput-underline:before': {
      border: `none !important`,
    },
    '& .inputEach': {},
  },
  screenWidthDisabled: {
    '& .inputEach': {
      borderBottom: `1px solid ${theme.palette.action.disabledBackground} !important`,
    },
  },
  screenContainer: {
    padding: 0,
  },
  screenContainerMobile: {
    maxWidth: 'none !important',
  },

  checklistContainer: {
    marginLeft: theme.spacing(1),
  },

  imagesContainer: {
    '& [type=secondarySub]': {
      marginBottom: theme.spacing(1),
    },

    '& .imagesList': {
      flexWrap: 'wrap',
      display: 'flex',
      flexDirection: 'row',
      position: 'relative',
    },

    '& .IMAGE': {
      paddingRight: theme.spacing(1),
    },
  },
  rowOutline: {
    borderBottom: `1px solid ${theme.palette.action.disabledBackground}`,
    padding: `${theme.spacing(2)} 0`,
    float: 'left',
    width: '100%',
  },

  commentContainer: {
    width: '100%',
    marginTop: theme.spacing(),
  },
  commentsWrap: {
    minHeight: theme.spacing(4),
  },
  commentCount: {
    fontSize: 13,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  commentBtnContainer: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
  commentBtn: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  createCommentContainer: {
    position: 'relative',
    backgroundColor: theme.palette.action.disabledBackground,
    width: '100%',
    marginTop: theme.spacing(2),
  },
  leftIcon: {
    position: 'absolute',
    top: 15,
    left: 10,
    width: 40,
    height: 40,
    backgroundColor: theme.palette.action.disabled,
    borderRadius: 40,
    color: theme.colors.white,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  textContainer: {
    width: '80%',
    marginLeft: '10%',
    marginRight: '10%',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  titleContainer: {
    fontSize: 13,
    marginBottom: theme.spacing(1),
  },
  correctionToggleContainer: {
    marginBottom: theme.spacing(2),

    '& .MuiToggleButtonGroup-root': {
      width: '100%',
    },
    '& .MuiToggleButtonGroup-root button': {
      width: '100%',
    },
  },
  correctionBtnIcon: {
    marginRight: theme.spacing(1),
  },
  commentText: {
    // backgroundColor: theme.colors.white,
  },
  addCommentPhoto: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  submitButtons: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',

    '& button': {
      marginRight: 0,
      marginLeft: theme.spacing(1),
      marginTop: theme.spacing(1),
    },
  },
  hideSmall: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  nextListItem: {
    position: 'fixed',
    right: 10,
    top: '48%',
    maxWidth: theme.spacing(6),
  },
  nextListItemLeft: {
    right: undefined,
    left: 10,
  },
  tagButton: {
    color: theme.colors.blue,
    borderColor: theme.colors.blue,
    marginBottom: theme.spacing(1),
  },
  tagRemove: {
    color: theme.colors.danger,
    borderColor: theme.colors.danger,
  },
  tagContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  refTitle: {
    fontSize: 12,
  },
  createdText: {
    fontStyle: 'italic',
    marginLeft: 'auto',
    fontSize: 14,
  },
}));

export default useStyles;
